export const merchantPortalSessionUrls = {
  local: {
    eu: {
      api: 'http://localhost:3012',
      ember: 'https://ember.staging.eu1.meta.klarna.net/v1',
      keycloak: 'https://keycloak.staging.eu1.meta.klarna.net',
      keycloakDomain: 'keycloak.staging.eu1.meta.klarna.net',
    },
    us: {
      api: 'http://localhost:3012',
      ember: 'https://ember.staging.us1.meta.klarna.net/v1',
      keycloak: 'https://keycloak.staging.us1.meta.klarna.net',
      keycloakDomain: 'keycloak.staging.us1.meta.klarna.net',
    },
    ap: {
      api: 'http://localhost:3012',
      ember: 'https://ember.staging.ap1.meta.klarna.net/v1',
      keycloak: 'https://keycloak.staging.ap1.meta.klarna.net',
      keycloakDomain: 'keycloak.staging.ap1.meta.klarna.net',
    },
  },
  staging: {
    eu: {
      api: 'https://portal.nonprod.klarna.net/api/eu/products',
      ember: 'https://ember.staging.eu1.meta.klarna.net/v1',
      keycloak: 'https://keycloak.staging.eu1.meta.klarna.net',
      keycloakDomain: 'keycloak.staging.eu1.meta.klarna.net',
    },
    us: {
      api: 'https://portal.nonprod.klarna.net/api/us/products',
      ember: 'https://ember.staging.us1.meta.klarna.net/v1',
      keycloak: 'https://keycloak.staging.us1.meta.klarna.net',
      keycloakDomain: 'keycloak.staging.us1.meta.klarna.net',
    },
    ap: {
      api: 'https://portal.nonprod.klarna.net/api/ap/products',
      ember: 'https://ember.staging.ap1.meta.klarna.net/v1',
      keycloak: 'https://keycloak.staging.ap1.meta.klarna.net',
      keycloakDomain: 'keycloak.staging.ap1.meta.klarna.net',
    },
  },
};

export const merchantWidgetSessionUrls = {
  local: {
    eu: {
      api: 'http://localhost:3012',
    },
    us: {
      api: 'http://localhost:3012',
    },
    ap: {
      api: 'http://localhost:3012',
    },
  },
  staging: {
    eu: {
      api: 'https://portal.nonprod.klarna.net/api/eu/products',
    },
    us: {
      api: 'https://portal.nonprod.klarna.net/api/us/products',
    },
    ap: {
      api: 'https://portal.nonprod.klarna.net/api/ap/products',
    },
  },
  playground: {
    eu: {
      api: 'https://playground.eu.portal.klarna.com/api/products',
    },
    us: {
      api: 'https://playground.us.portal.klarna.com/api/products',
    },
    ap: {
      api: 'https://playground.oc.portal.klarna.com/api/products',
    },
  },
};

export const onboardingBeUrls = {
  local: {
    eu: {
      api: 'http://localhost:3012',
      platforms: 'http://localhost:3012/v2/platforms',
    },
    us: {
      api: 'http://localhost:3012',
      platforms: 'http://localhost:3012/v2/platforms',
    },
    ap: {
      api: 'http://localhost:3012',
      platforms: 'http://localhost:3012/v2/platforms',
    },
  },
  staging: {
    eu: {
      api: 'https://portal.nonprod.klarna.net/api/eu/products',
      platforms: 'https://portal.nonprod.klarna.net/api/eu/signup/v2/platforms',
    },
    us: {
      api: 'https://portal.nonprod.klarna.net/api/us/products',
      platforms: 'https://portal.nonprod.klarna.net/api/us/signup/v2/platforms',
    },
    ap: {
      api: 'https://portal.nonprod.klarna.net/api/ap/products',
      platforms: 'https://portal.nonprod.klarna.net/api/ap/signup/v2/platforms',
    },
  },
  playground: {
    eu: {
      api: 'https://playground.eu.portal.klarna.com/api/products',
      platforms: 'https://playground.eu.portal.klarna.com/api/signup/v2/platforms',
    },
    us: {
      api: 'https://playground.us.portal.klarna.com/api/products',
      platforms: 'https://playground.us.portal.klarna.com/api/signup/v2/platforms',
    },
    ap: {
      api: 'https://playground.oc.portal.klarna.com/api/products',
      platforms: 'https://playground.oc.portal.klarna.com/api/signup/v2/platforms',
    },
  },
  production: {
    eu: {
      api: 'https://eu.portal.klarna.com/api/products',
      platforms: 'https://eu.portal.klarna.com/api/signup/v2/platforms',
    },
    us: {
      api: 'https://us.portal.klarna.com/api/products',
      platforms: 'https://us.portal.klarna.com/api/signup/v2/platforms',
    },
    ap: {
      api: 'https://oc.portal.klarna.com/api/products',
      platforms: 'https://oc.portal.klarna.com/api/signup/v2/platforms',
    },
  },
};
